import keyMirror from 'keymirror-nested'

export default keyMirror({
  CARRIER_LIST: {
    FETCH: {
      SHIPMENT_REQUEST: null,
      QUOTE_REQUEST: null,
      SUCCEEDED: null,
      FAILED: null,
    },
    CLEAN: {
      ERRORS: null,
      STATE: null,
    },
  },
})
